<template>
  <el-container>
    <div class="header-wrap">
      <div class="header-wrap__inner">
        <div class="logo">
          <img :src="logo" alt="logo" style="vertical-align: middle" width="35px" height="37px" />
          <span style="margin-left: 5px">上海市法人统一认证平台</span>
        </div>
      </div>
      <div class="header-wrap__menu" v-if="false">
        <el-menu class="menu-wrap" :default-active="activeIndex" mode="horizontal">
          <el-menu-item index="1">云端证书认证</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="main-wrap">
      <router-view />
    </div>
    <el-footer v-if="false" class="footer"> copyright@上海市数字证书认证中心有限公司 </el-footer>
  </el-container>
</template>

<script>
import { mapActions } from 'vuex';
import logo from '../assets/logo.png';
import exit from '../assets/exit.png';
export default {
  data() {
    return {
      logo,
      exit,
      activeIndex: '1'
    };
  },
  methods: {
    ...mapActions('frfwCert', ['redirectPage']),
    async closeWin() {
      // const ua = window.navigator.userAgent;
      // if (ua.indexOf('MSIE') > 0) {
      //   if (ua.indexOf('MSIE 6.0') > 0) {
      //     window.opener = null;
      //     window.close();
      //   } else {
      //     window.open('', '_top');
      //     window.top.close();
      //   }
      // } else {
      //   window.open('', '_self', ''); //bug fix
      //   window.close();
      // }
      try {
        const { callbackUrl } = await this.redirectPage();
        window.open(callbackUrl, '_self');
      } catch (err) {
        this.$message.error(err.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../style/variable.less');
.header-wrap {
  position: fixed;
  top: 0;
  width: 100%;
  background: @blue-300;
  z-index: 100;
  &__inner {
    padding: 10px;
    margin: auto;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    .logo {
      font-size: 20px;
    }
    .exit {
      font-size: 14px;
      cursor: pointer;
    }
  }
  &__menu {
    background: #fff;
    .menu-wrap {
      margin: auto;
      width: 1200px;
    }
  }
}
.main-wrap {
  box-sizing: border-box;
  width: 1200px;
  margin: 80px auto 0;
  background: #fff;
  border: 1px solid @border-color;
  padding: 0 10px;
}
.footer {
  text-align: center;
  margin-top: 30px;
  font-size: 12px;
  color: #cecfcf;
}
</style>
